import React from 'react'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import ResearchKodaBlock from '../../../ResearchKodaBlock/ResearchKodaBlock'
import s from '../CourseCard/styles/CourseCard.module.scss'

const SkeletonCourseCard = () => {
	return (
		<article className={`${s.card} ${s.skeleton}`}>
			<header className={s.head}>
				<span className={s.icon}>
					<span className={s.skeletonBlock} style={{ width: 28, height: 28 }} />
				</span>
				<span className={s.title}>
					<span className={s.skeletonBlock} style={{ width: 110, height: 16 }} />
				</span>
				<span className={s.btn}>
					<span className={s.skeletonBlock} style={{ width: 52, height: 12 }} />
				</span>
			</header>
			<div className={s.card__inner}>
				<div className={s.metrics}>
					<div className={s.metric}>
						<span className={s.metric__label}>Average tuition fees</span>
						<strong className={s.metric__value}>
							<span className={s.skeletonBlock} style={{ width: 70, height: 14 }}>
								<LoaderImg color="green" />
							</span>
						</strong>
					</div>
					<div className={s.metric}>
						<span className={s.metric__label}>Course duration</span>
						<strong className={s.metric__value}>
							<span className={s.skeletonBlock} style={{ width: 60, height: 14 }}>
								<LoaderImg color="orange" />
							</span>
						</strong>
					</div>
				</div>
				<div className={s.skills}>
					<span className={s.skills__title}>Curriculum subjects</span>
					<div className={s.skills__list}>
						{[1, 2, 3].map(item => (
							<em key={item} className={s.skills__item}>
								<span className={s.skeletonBlock} style={{ width: 48, height: 10 }}>
									<LoaderImg />
								</span>
							</em>
						))}
					</div>
				</div>
				<ResearchKodaBlock loading />
			</div>
		</article>
	)
}

export default SkeletonCourseCard
